// *****************************************************************************
// Toggle header classes on hamburger click
// *****************************************************************************

const mobileMenu = document.querySelector('.menu');
const hamburger = document.querySelector('.hamburger');

const toggleMenu = (open) => {
  document.body.classList.toggle('is-open-menu', open);

  if (mobileMenu) {
    slideToggle(mobileMenu, 300, 'block');
  }
};

hamburger?.addEventListener('click', () => {
  const isOpen = document.body.classList.contains('is-open-menu');
  toggleMenu(!isOpen);
});

// *****************************************************************************
// Add scroll-related classes to body
// *****************************************************************************

let lastScrollTop = 0;
let ticking = false;

const updateScrollClasses = () => {
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

  document.body.classList.toggle('is-scrolled', scrollTop > 30);
  document.body.classList.toggle('is-scrolled-up', scrollTop < lastScrollTop);

  lastScrollTop = Math.max(scrollTop, 0);
  ticking = false;
};

const onScroll = () => {
  if (!ticking) {
    window.requestAnimationFrame(updateScrollClasses);
    ticking = true;
  }
};

// Initial check and scroll event listener
updateScrollClasses();
window.addEventListener('scroll', onScroll);

// *****************************************************************************
// Update CSS variable for dynamic header height
// *****************************************************************************

const header = document.querySelector('.site-header');

const updateHeaderHeight = () => {
  const height = header?.offsetHeight || 0;
  document.documentElement.style.setProperty('--header-height', `${height}px`);
};

updateHeaderHeight();
window.addEventListener('resize', updateHeaderHeight);

// ------
// Search
// ------
const searchInput = document.querySelector('.header-search__input-field');
const headerSearch = document.querySelector('.header-search');
const resetBtn = document.querySelector('.header-search__reset');
const searchField = document.querySelector('#header-search');
const searchForm = document.querySelector('.header-search__form');
const searchResultWrapper = document.querySelector('.header-search__wrapper');
const searchTrigger = document.querySelector('.header-main__search-trigger');

if (searchInput) {
  const toggleSearchClass = (toggle) => {
    document.body.classList.toggle('is-open-search', toggle);
    toggleBodyScrollLock(toggle);
    toggleHideClass(searchResultWrapper, !toggle);

    if (toggle) {
      searchInput.focus();
    } else {
      searchInput.blur();
    }
  };

  const resetSearchHtml = () => {
    searchField.value = '';
    searchInput.blur();
    headerSearch.classList.remove('has-value');
    searchForm.reset();
    searchHeaderPosts({ value: '////' });
    toggleSearchClass(false);
  };

  attachEvent('.header-search__close', 'click', () => {
    document.body.classList.remove('is-open-search');
    resetSearchHtml();
  });

  searchInput.addEventListener('input', () => {
    headerSearch.classList.toggle('has-value', !!searchField.value.trim());
  });

  resetBtn.addEventListener('click', () => {
    resetSearchHtml();
  });

  searchTrigger.addEventListener('click', () => {
    toggleSearchClass(true);
  });

  searchField.addEventListener('focus', () => {
    toggleSearchClass(true);
  });

  searchField.addEventListener('blur', () => {
    if (!searchField.value.trim()) {
      resetSearchHtml();
    }
  });

  onKeydown('escape', () => {
    resetSearchHtml();
  });

  // ------
  // Search - Result Ajax
  // ------
  const searchHeaderPosts = async (search, key = '') => {
    const searchResultLinks = headerSearch.querySelector('.header-search__links-wrapper');
    const searchResultLinksSuggestion = headerSearch.querySelector('.header-search__links-suggestion-wrapper');
    const searchResultProducts = headerSearch.querySelector('.header-search__products-wrapper');
    const searchResultNotFound = headerSearch.querySelector('.header-search__not-found-wrapper');

    // If search input is empty, trigger a default search
    if (!search.value) {
      await searchHeaderPosts({ value: '////' });
      return;
    }

    try {
      const response = await axios.post(
        localData.apiURL,
        {
          action: 'searchPostsHeader',
          keyword: search.value,
          lang: localData.lang,
          keyboardKey: key,
        },
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        },
      );

      // Clear previous results
      searchResultLinksSuggestion.innerHTML = '';
      searchResultProducts.innerHTML = '';
      searchResultNotFound.innerHTML = '';

      searchResultProducts.classList.remove('hide');
      searchResultLinks.classList.add('hide');

      // Inject new content based on the response
      if (response.data.html_links) {
        searchResultLinksSuggestion.innerHTML = response.data.html_links;
      }

      if (response.data.html_products) {
        searchResultProducts.innerHTML = response.data.html_products;
      }

      if (!response.data.html_links && !response.data.html_products) {
        searchResultNotFound.classList.remove('hide');
        searchResultNotFound.innerHTML = `
        <div class="header-search__not-found : text--bd">
          ${response.data.no_results_found_text}
        </div>
      `;
      }
    } catch (error) {
      console.error('Error fetching search results:', error);
    }
  };

  searchField.addEventListener(
    'keyup',
    debounce((e) => {
      if (e.key === 'Escape') {
        toggleSearchClass(false);
      }
      searchHeaderPosts(searchField, e.key);
    }, 450),
  );

  // ------
  // Search - Load more
  // ------
  attachEvent('.header-search__products-more', 'click', (ev) => {
    const loadMoreProductBtn = ev.target.closest('.header-search__products-more');
    const hiddenItems = document.querySelectorAll('.header-search__products-items.hide');

    if (!hiddenItems) return;

    hiddenItems.forEach((el, i) => {
      if (i < 8) {
        toggleHideClass(el, false);
      }

      const remainingItems = document.querySelectorAll('.header-search__products-items.hide');

      if (remainingItems.length === 0) {
        toggleHideClass(loadMoreProductBtn, true);
      }
    });

    ev.preventDefault();
  });

  // ------
  // Search - click on result item
  // ------
  attachEvent('.header-search__results-repeater button.header-search__result', 'click', (ev) => {
    ev.preventDefault();
    if (ev.target.innerText) {
      const searchTerm = ev.target.closest('.header-search__result').innerText;
      searchHeaderPosts({ value: searchTerm });
      searchInput.focus();
      searchInput.value = searchTerm;
    }
  });
}
document.addEventListener('DOMContentLoaded', () => {
  const isLogin = document.cookie.split(';').some((cookie) => {
    const [name] = cookie.trim().split('=');
    return name.startsWith('wordpress_logged_in_') || name.startsWith('wp-settings-time-');
  });

  const t = localData?.translations?.header;
  const h = document.querySelector('.header-main .menu__acc');

  if (isLogin && t && h) {
    const btnPrimary = h.querySelector('.btn--primary');
    const modLink = h.querySelector('.mod-link');
    const accText = h.querySelector('.menu__acc-text');

    btnPrimary.innerHTML = t.login_button_1_text;
    btnPrimary.href = t.login_button_1_link;

    const icon = modLink.querySelector('i');
    modLink.removeChild(icon);
    modLink.textContent = t.login_button_2_text;
    modLink.appendChild(icon);
    modLink.href = t.login_button_2_link;

    accText.hidden = true;
  }
});
